// index.js
// ÄLÄ POISTA TÄTÄ TIEDOSTOA.
// Tämä on Parcelin entry point (package.json: "./src/*.js") ja base.njk lataa
// tämän tiedoston <script>-tagilla jokaisella sivulla. Jos tiedosto poistetaan,
// Parcel ei tuota dist/index.js-tiedostoa ja kaikilla sivuilla tulee 404-virhe.
//
// Kuvat ja videot palvellaan Eleventyn passthrough copy -toiminnolla (src/images -> dist/images)
// ja {% image %} shortcoden kautta. Parcel url: -importteja ei tarvita.
